import React from 'react';
import { Box, FileUpload, AddItem, ImageViewer } from '@wix/design-system';
import { MAXIMUM_FILES } from '../consts';
export const ImageUploader = _ref => {
  let {
    images,
    isLoading,
    uploadButtonText,
    supportedFormats,
    errorsMessages,
    handleFileSelected,
    handleRemoveImage,
    isCompleted
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, images.length === 0 ? /*#__PURE__*/React.createElement(FileUpload, {
    multiple: true,
    onChange: files => handleFileSelected(files, errorsMessages),
    accept: ".jpeg,.png,.jpg"
  }, _ref2 => {
    let {
      openFileUploadDialog
    } = _ref2;
    return /*#__PURE__*/React.createElement(AddItem, {
      disabled: isCompleted,
      showIcon: false,
      size: "large",
      subtitle: supportedFormats,
      onClick: openFileUploadDialog
    }, uploadButtonText);
  }) : /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "12px"
  }, images.map((image, index) => /*#__PURE__*/React.createElement(ImageViewer, {
    disabled: isCompleted,
    status: isLoading ? 'loading' : undefined,
    height: 90,
    width: 90,
    key: image,
    onRemoveImage: () => {
      handleRemoveImage(index);
    },
    showUpdateButton: false,
    imageUrl: image
  })), /*#__PURE__*/React.createElement(FileUpload, {
    multiple: true,
    onChange: files => handleFileSelected(files, errorsMessages),
    accept: ".jpeg,.png,.jpg"
  }, _ref3 => {
    let {
      openFileUploadDialog
    } = _ref3;
    return /*#__PURE__*/React.createElement(React.Fragment, null, images.length < MAXIMUM_FILES && /*#__PURE__*/React.createElement(Box, {
      height: 90,
      width: 90
    }, /*#__PURE__*/React.createElement(AddItem, {
      disabled: isCompleted,
      size: "medium",
      onClick: openFileUploadDialog
    })));
  }))));
};
export default ImageUploader;
//# sourceMappingURL=ImageUploader.js.map